<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <search-form-template
      ref="storeTemplate"
      :searchOptions="storeSearchOptions"
      :toolConfig="toolConfig"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      @btnCommon="btnCommon"
    ></search-form-template>
    <el-tabs v-model="activeTab" >
      <el-tab-pane label="销售趋势分析" name="trendAnalyse">
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template
              class="charts-box"
              ref="trendTrendEcharts"
              :picOption="trendTrendEcharts"
            >
            </echarts-template>
          </div>
          <list-template ref="trend" :tableOptions="trendTable" :tableData="trendList">
          </list-template>
        </div>
      </el-tab-pane>
      <el-tab-pane label="销售总额分析" name="totalAnalyse">
        <div class="centerBack">
          <div class="echartsArea">
            <echarts-template
              class="charts-box-category"
              ref="totalAnalyseEcharts"
              :picOption="totalAnalyseEcharts"
            >
            </echarts-template>
          </div>
          <list-template ref="total" :tableOptions="totalTable" :tableData="totalList">
          </list-template>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import api from "@/config/api";
  import searchFormTemplate from "@/components/template/searchFormTemplate";
  import echartsTemplate from "@/components/controls/echarts";
  import listTemplate from "@/components/template/listTemplate";
  import {totalAnalyseEcharts, trendTrendEcharts,} from "@/page/home/options/saleReportEcharts";
  import userPower from "@/mixin/userPower";

  export default {
  mixins: [userPower],
  components: { searchFormTemplate, echartsTemplate, listTemplate },
  created() {
     this.getTotalList(this.param)
     this.getTrandList(this.param)
     this.setStore(this.storeSearchOptions.simple);
     this.getTrendAnalyse(this.param),
     this.getTotalAnalyse(this.param),
     this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 40);
  },
  beforeDestroy() {
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
  },

  data() {
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
      type:"",
      param:defaultParam,
      trendTrendEcharts,
      totalAnalyseEcharts,
      title: "",
      trendList:[],
      totalList:[],
      activeTab: "trendAnalyse",
      storeSearchOptions: {
        simple: [
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            url: api.store.store,
          },
          {
            label:'',
            type:'radio',
            prop:'dateType',
            span:12,
            data:[{label:"按小时",value:10},{label:"按天",value:20},{label:"按月",value:30}],
            defaultValue:10,
            change:this.timeChoose
          },
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "datetimeRange",
            dateType: "datetime",
            span: 24,
          },
        ],
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
          callback: this.exportData,
        },
      ],
      trendTable: {
        showSummary: true,
        summaryColumns: ['orderNum', 'goodsNum', 'amountReceived', 'profit'],
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "时间",
            prop: "dateTime",
            width: "200",
            align: "center",
          },
          {
            label: "销售单数",
            prop: "orderNum",
            width: "180",
            align: "center",
          },
          {
            label: "商品数量",
            prop: "goodsNum",
            width: "180",
            align: "center",
          },
          {
            label: "销售总额",
            prop: "amountReceived",
            width: "180",
            align: "center",
          },
          {
            label: "利润",
            prop: "profit",
            width: "180",
            align: "center",
          },
          {
            label: "毛利率",
            prop: "profitRate",
            width: "170",
            align: "center",
          },
          {
            label: "库存占比",
            prop: "inventoryRate",
            width: "170",
            align: "center",
          },
        ],
      },
      totalTable: {
        showSummary: true,
        summaryColumns: ['orderNum', 'amountReceived'],
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "时间",
            prop: "dateTime",
            width: "290",
            align: "center",
          },
          {
            label: "销售单数",
            prop: "orderNum",
            width: "250",
            align: "center",
          },
          {
            label: "销售总额",
            prop: "amountReceived",
            width: "230",
            align: "center",
          },
          {
            label: "平均每单商品数",
            prop: "goodsAverage",
            width: "230",
            align: "center",
          },
          {
            label: "商品均价",
            prop: "priceAverage",
            width: "240",
            align: "center",
          },
        ],
      },
    };
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    getTrendAnalyse(param) {
        let params={dateType:this.type||20}
        let $params = Object.assign({},params,param);
      this.$axios
        .fetchPost(api.report.trendEcharts,$params)
        .then((data) => {
          if (data.code == 200) {
            this.trendTrendEcharts.charsOption.xAxis[0].data =
              data.data.dateTime;
            this.trendTrendEcharts.charsOption.series[0].data =
              data.data.amountReceived;
            this.trendTrendEcharts.charsOption.series[1].data =
              data.data.orderNum;
            this.trendTrendEcharts.charsOption.series[2].data =
              data.data.goodsNum;
            this.trendTrendEcharts.charsOption.series[3].data =
              data.data.profit;
            this.trendTrendEcharts.charsOption.series[4].data =
            data.data.profitRate;
            this.trendTrendEcharts.charsOption.series[5].data =
            data.data.inventoryRate;
            this.$nextTick(() => {
              this.$refs.trendTrendEcharts.drawpic();
            });
          }
        })
        .catch((err) => {
          this.$message({ message: "请求失败！", type: "error" });
        });
    },
    getTrandList(param){
      let params={dateType:this.type||20}
      let $params = Object.assign({},params,param);
      this.$axios.fetchPost(api.report.trendList,$params).then((data)=>{
        this.trendList = data.data;
      })
    },
    getTotalList(param){
      let params={dateType:this.type||20}
      let $params = Object.assign({},params,param);
      this.$axios.fetchPost(api.report.totalList,$params).then((data)=>{
        this.totalList = data.data;
      })
    },
    getTotalAnalyse(param) {
        let params={dateType:this.type||20}
        let $params = Object.assign({},params,param);
      this.$axios
        .fetchPost(api.report.totalEcharts,$params)
        .then((data) => {
          if (data.code == 200) {
            // console.log(data)
            this.totalAnalyseEcharts.charsOption.xAxis[0].data =
              data.data.dateTime;
            this.totalAnalyseEcharts.charsOption.series[0].data =
              data.data.amountReceived;
            this.totalAnalyseEcharts.charsOption.series[1].data =
              data.data.orderNum;
            this.totalAnalyseEcharts.charsOption.series[2].data =
              data.data.goodsAverage;
            this.totalAnalyseEcharts.charsOption.series[3].data =
              data.data.priceAverage;
            this.$nextTick(() => {
              this.$refs.totalAnalyseEcharts.drawpic();
            });
          }
        })
        .catch((err) => {
          this.$message({ message: "请求失败！", type: "error" });
        });
    },
    searchSubmit() {
        const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams());
        if(this.type==""||this.type=="10"){
          let $param = Object.assign({}, {stCreateDttm: this.param.stCreateDttm}, simpleParams);
          this.getTrendAnalyse($param);
          this.getTrandList($param);
          this.getTotalAnalyse($param);
          this.getTotalList($param);
        }else{
          let $param = Object.assign({}, this.param, simpleParams);
          this.getTrendAnalyse($param);
          this.getTrandList($param);
          this.getTotalAnalyse($param);
             this.getTotalList($param)
        }
    },
    clearSearch() {
      this.getTrendAnalyse(this.param);
      this.getTrandList(this.param);
      this.getTotalAnalyse(this.param);
        this.getTotalList(this.param)
    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    timeChoose(data){
      this.type = data.dateType;
      let doubleTime=this.storeSearchOptions.simple.filter(item=>item.dateType =="datetime")[0]
      if(data.dateType==10){
        doubleTime.prop = "stCreateDttm";
            doubleTime.type ='dateTimePicker'
      }else{
        doubleTime.prop = "CreateDttm";
           doubleTime.type ='datetimeRange'
      }
    },
    exportData(){
      const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams());
      let params = {dateType: this.type || 10};
      let url;
      let fileName;
      let exportcode = {exportCode: 'SoSalesAnalysisExport'};
      let $params = Object.assign({}, {stCreateDttm: this.param.stCreateDttm}, params, simpleParams, exportcode);
      if (this.activeTab === "trendAnalyse") {
        url = api.report.trendExport;
        fileName = '销售趋势分析.xls';
      }
      if (this.activeTab === "totalAnalyse") {
        url = api.report.totalExport;
        fileName = '销售总额分析.xls';
      }
      this.$axios.fetchPost(url, $params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    },
  },
};
</script>

<style scoped>
.page-template .centerBack {
  width: 100%;
  /* height: calc(100vh - 62px); */
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
}

.page-template .echartsArea {
  width: 100%;
  height:500px;
  margin-bottom: 12px;
}
.charts-box-category {
  height: 500px;
  width: calc(100vw - 200px);
}
</style>



// WEBPACK FOOTER //
// src/page/report/sales/Trend.vue